import Client from "../client/FireBase"

const createTokenFirebase = (data) => {
  return Client.post(`api/device`, data)
}

const subscribeNoti = (data) => {
  return Client.post(`api/subcribe-noti`, data)
}

const unSubscribeNoti = (data) => {
  return Client.post(`api/un-subcribe-noti`, data)
}

const subNotiChannel = (data, tokenDevice, sessionID) => {
  return Client.put(`api/notify/fdg`, data, {
    headers: {
      TokenDevice: tokenDevice,
      SessionID: sessionID
    }
  })
}

const userRepository = {
  createTokenFirebase,
  subscribeNoti,
  unSubscribeNoti,
  subNotiChannel
}
export default userRepository
